import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

interface PermissionGuardProps {
  children: React.ReactNode;
  permission?: string;
  permissions?: string[];
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({ 
  children, 
  permission, 
  permissions 
}) => {
  const { hasPermission, hasAnyPermission, isLoading, user } = useAuth();

  // Esperar a que el usuario se cargue
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Si no hay usuario, redirigir al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/ensayos" replace />;
  }

  if (permissions && !hasAnyPermission(permissions)) {
    return <Navigate to="/ensayos" replace />;
  }

  return <>{children}</>;
};

